export const AchievmentWinInRow4Level = () => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 0H27.0517L29.069 0.207951L30.6207 0.46789L32.3276 0.883792L33.7241 1.29969L34.8621 1.7156L36.2069 2.28746L37.3966 2.85933L38.5862 3.53517L39.4138 4.05505L40.3448 4.6789L41.2241 5.35474L41.8966 5.87462L42.4138 6.34251L42.8276 6.70642L43.3448 7.17431L44.431 8.26606L44.7931 8.68196L45.4655 9.46177L46.1897 10.4495L46.6035 11.0214L46.9655 11.5413L47.5345 12.4771L48.1552 13.5688L48.7241 14.7125L49.3448 16.2202L49.8103 17.4679L50.2759 19.1315L50.6379 20.7431L50.8448 22.0948L50.9483 23.0306L51 23.8104V27.1376L50.8966 28.3333L50.7414 29.5291L50.4828 30.8287L50.1724 32.1284L49.7586 33.4801L49.1897 35.0917L48.569 36.4954L48.0517 37.4832L47.6379 38.263L46.9655 39.3547L46.3966 40.1865L45.9828 40.7584L45.4655 41.4342L44.8966 42.1101L44.431 42.63L43.9655 43.1498L42.8793 44.2416L42.4655 44.6055L41.9483 45.0734L40.9138 45.8532L40.2414 46.3731L39.2069 47.0489L38.5345 47.4648L37.6035 47.9847L36.4138 48.6086L35.3793 49.0765L33.931 49.6483L32.0172 50.2202L30.6724 50.5321L29.1724 50.792L27.4138 50.948L26.6379 51H24L22.6034 50.896L20.8966 50.6361L19.4483 50.3242L18.0517 49.9602L17.1207 49.6483L15.6207 49.0765L14.1724 48.4006L12.6207 47.5688L11.4828 46.841L10.4483 46.1131L9.51724 45.3853L8.84483 44.8135L8.12069 44.1376L7.7069 43.7737L7.08621 43.1498L6.72414 42.7339L6.41379 42.37L6.15517 42.1101L5.53448 41.3823L4.91379 40.5505L4.2931 39.6667L3.72414 38.7309L3.25862 37.9511L2.63793 36.7554L2.12069 35.6636L1.55172 34.208L1.03448 32.6483L0.724138 31.4526L0.517241 30.5168L0.310345 29.4251L0.155172 28.1254L0 25.7859L0.0517241 24.0183L0.155172 22.8226L0.310345 21.5749L0.62069 19.9113L0.87931 18.7676L1.34483 17.2599L1.86207 15.8563L2.43103 14.5566L2.84483 13.6728L3.36207 12.737L3.98276 11.6972L4.65517 10.7095L5.27586 9.87768L5.84483 9.14985L6.36207 8.57798L6.72414 8.16208L7.44828 7.38226L7.86207 6.96636L8.27586 6.60245L8.53448 6.34251H8.63793V6.23853L9.2069 5.77064L9.46552 5.56269H9.56897V5.45872L10.1379 5.04281L10.7069 4.62691L11.6379 4.00306L12.569 3.43119L13.3966 2.9633L14.3793 2.44343L15.6724 1.87156L16.8621 1.40367L18.569 0.883792L20.4828 0.415902L22.1379 0.155963L24 0ZM23.8966 2.07951L21.8793 2.28746L20.3276 2.59939L18.7241 3.01529L17.1724 3.53517L16.1379 3.95107L14.6897 4.62691L13.9138 5.04281L12.7759 5.71865L11.9483 6.29052L11.0172 6.96636L10.4483 7.43425L9.72414 8.0581L8.89655 8.83792L8.48276 9.25382L8.12069 9.66972L7.96552 9.82569V9.92966L7.81035 9.98165L7.24138 10.7095L6.72414 11.3333L6.05172 12.2691L5.68966 12.841L5.06897 13.8287L4.2931 15.3364L3.72414 16.5841L3.15517 18.1437L2.68966 19.8073L2.43103 21.055L2.17241 22.7187L2.01724 24.9021V25.9419L2.12069 27.6575L2.32759 29.2691L2.58621 30.6208L3 32.1804L3.46552 33.5841L3.87931 34.6239L4.44828 35.8716L5.06897 37.1193L5.7931 38.263L6.41379 39.1468L6.82759 39.6667L7.03448 39.8746L7.39655 40.4465L7.91379 41.0183L8.27586 41.4342L9.56897 42.7339L9.98276 43.0979L10.6552 43.6697L11.5862 44.3976L13.1379 45.4373L14.2241 46.0612L15.6207 46.789L16.9655 47.3609L18.2586 47.8287L19.6552 48.2446L21 48.5566L22.2931 48.7645L23.7414 48.9205L24.9828 48.9725H26.431L27.931 48.8685L29.2241 48.7125L30.7241 48.4006L32.2759 47.9847L33.8276 47.4648L35.069 46.945L36 46.5291L37.1897 45.8532L38.1724 45.2813L39.2586 44.5535L40.1379 43.8777L40.8621 43.3058L41.5345 42.682L42.4138 41.8502L42.8793 41.3823L43.2414 40.9664L43.9655 40.0826L44.431 39.4587L45.1035 38.5229L45.7241 37.5352L46.2414 36.5994L46.7069 35.7156L47.2759 34.4159L47.7931 33.0642L48.2586 31.4526L48.6207 29.893L48.8793 28.2294L49.0345 26.2538V25.0581L48.931 23.3425L48.7241 21.6789L48.4655 20.2752L48.1552 19.0275L47.5345 17.156L47.1207 16.1162L46.2931 14.4006L45.7759 13.4648L45.2069 12.581L44.5345 11.5933L44.0172 10.9694L43.6035 10.4495L43.1379 9.92966L42.7759 9.51376L41.5862 8.31804L41.0172 7.85015L40.8621 7.69419H40.7586V7.59021L39.8793 6.91437L38.9483 6.23853L38.069 5.66667L37.0345 5.04281L36.3103 4.6789L35.4828 4.263L34.2931 3.74312L32.7414 3.17125L31.8103 2.91131L30.1552 2.49541L28.1897 2.18349L27.1552 2.07951H23.8966Z"
      fill="#C6B7FF"
    />
    <path
      d="M20.2762 3.37915H20.8452L21.0521 3.53511L21.0004 5.35469L20.8969 5.45866H20.3797L20.328 5.40667L20.2762 4.67884H20.0693L20.1211 3.5871L20.2762 3.37915Z"
      fill="#C6B7FF"
    />
    <path
      d="M30.3621 3.48315H30.7242L30.8277 3.58713V5.56266L30.6208 5.66664H30.207L30.1552 5.56266L30.1035 4.36695V3.63912L30.3621 3.48315Z"
      fill="#C6B7FF"
    />
    <path
      d="M25.241 3.53516H25.8099L26.1203 3.63913L26.4306 3.84708L26.7927 4.26298L26.9479 4.67889V5.09479L26.741 5.66665L26.3789 6.03057L25.9134 6.29051L25.8616 6.81039L25.9651 9.09785L25.4479 9.14984L25.2927 9.04586L25.241 8.78592L25.1892 7.95412L25.1375 6.29051L24.6203 5.97858L24.2582 5.56268L24.103 5.19876L24.1548 4.52292L24.3616 4.10702L24.7754 3.74311L25.241 3.53516Z"
      fill="#C6B7FF"
    />
    <path
      d="M34.6552 4.99072L35.2242 5.0947L35.3794 5.30265V7.53812H34.9139L34.707 7.43415L34.6552 5.61458L34.6035 5.45861V5.0947L34.6552 4.99072Z"
      fill="#C6B7FF"
    />
    <path
      d="M15.6726 5.04272H16.4484L16.7071 5.19869L16.8622 5.71857L16.9657 6.29043L17.0174 7.12224L16.8105 7.43416L16.6036 7.59013L15.8795 7.64211L15.5691 7.53814L15.414 7.38217L15.2588 6.70633V5.66658L15.4657 5.25068L15.6726 5.04272ZM15.9312 5.82254V7.12224L16.2933 7.07025L16.345 6.96627V6.55037L16.2415 5.82254H15.9312Z"
      fill="#C6B7FF"
    />
    <path
      d="M20.3789 6.23853H20.8961L21.4134 6.44648L21.672 6.70642L21.9823 7.12232L22.0858 7.43424V7.85015L21.9306 8.31804L21.5685 8.73394L21.103 8.99388L21.0513 9.20183L20.9996 10.6575L20.9478 11.1774L22.2927 10.5535L23.172 10.2416L24.4134 9.98164L24.8271 9.92966H26.2754L27.2582 10.0856L28.2409 10.3975L29.1203 10.7615L29.9478 11.1774V10.3456L30.103 9.14984L30.1547 8.99388L29.7927 8.8899L29.3271 8.42201L29.172 8.16207L29.1203 7.59021L29.3271 6.96635L29.534 6.65443L29.8444 6.44648L30.1547 6.3425H30.8271L31.4478 6.60244L31.8099 7.01834L31.9134 7.27828V8.00611L31.7065 8.42201L31.3444 8.78593L30.9306 8.99388H30.8271V9.82568L30.7754 11.8012L30.9823 12.0612L31.3961 12.4251L32.1203 13.1529L32.4306 13.5688L32.5858 13.9327L32.9996 13.8807L33.7237 13.7248H34.603L35.3789 13.8807L36.2065 14.2446L36.7754 14.6086L37.2927 15.0245L37.603 15.3884L37.8616 15.8043L38.1203 16.3761V16.4801L38.7409 16.5321L39.3616 16.792L39.9306 17.2079L40.2927 17.5719L40.603 17.9878L40.9134 18.6636L41.1203 19.3394L41.172 20.1193L41.0685 20.9511L40.8099 21.6269L40.4996 22.1468L40.034 22.6667L39.3099 23.3945L38.4823 23.7584L38.0168 23.8624H36.8789L36.2065 23.6544L35.6375 23.3945L35.4306 23.4465L34.7065 23.9664L34.1375 24.2263L33.4134 24.4342L32.9478 24.4862H32.1203L31.2927 24.3303L30.5168 24.0183L29.8444 23.6544L29.7409 23.9664L29.4306 24.6942L29.1203 25.7339L28.9134 26.7737L28.7582 28.5413L28.7065 29.893L29.2754 29.9449L31.3961 30.2569L32.3789 30.5168L33.0513 30.7768L33.6203 31.1927L33.9823 31.5566L34.0858 31.7645L33.9823 32.3364L33.7237 32.7523L33.2582 33.0642L32.0168 33.4801L31.1375 33.6881L29.2754 33.896V34.3639L29.7409 35.8716L30.3099 37.3272L30.7237 38.159L31.2409 39.0948L31.8099 39.9266L32.4306 40.7584L32.6375 40.8624L33.3099 40.5505L34.0858 40.3945H35.0168L35.6892 40.5505L36.3616 40.9144L36.8789 41.3823L36.9823 41.5902H37.0858L37.4996 42.266L37.6547 42.526L37.8099 42.578L39.1547 42.6819L39.4134 42.9939V43.3058L39.3099 43.5138L11.7409 43.5657L11.534 43.3058L11.4823 43.0459L11.6375 42.7859L12.103 42.63L13.3961 42.578L13.4478 42.2141L13.603 41.8501L13.9134 41.3303L14.3789 40.9144L15.1547 40.4985L15.7237 40.3425L16.1375 40.2905H16.8099L17.534 40.4465L18.1547 40.7064L18.4134 40.8104L18.8271 40.4465L19.3444 39.6667L19.9134 38.6269L20.3271 37.9511L20.7409 37.1193L21.2065 36.0275L21.4651 35.0917L21.6203 34.3639L21.672 33.896L20.3789 33.7401L18.9823 33.4281L18.2582 33.1682L17.2237 32.5963L16.9651 32.0764L17.0168 31.7125L17.4306 31.1407L17.8444 30.8807L18.6203 30.5688L19.9134 30.2569L21.4134 30.0489L22.0858 29.9449L22.2927 29.841V28.8012L22.1375 27.1896L21.8789 25.9419L21.5168 24.6942L21.0513 23.3945L20.4823 23.7584L19.6547 24.1743L18.8789 24.3823L18.5168 24.4342H17.4823L16.603 24.2263L15.7754 23.8104L15.3616 23.6024L14.4823 24.0183L14.0685 24.1223H13.1375L12.3616 23.9144L11.5858 23.4985L10.9134 22.9266L10.3444 22.1988L10.0858 21.6789L9.87887 21.0031L9.82715 20.5352V19.8593L9.9306 19.1835L10.1892 18.5076L10.4996 17.9878L10.9651 17.4679L11.4306 17.052L11.9478 16.7401L12.7237 16.5321L13.1375 15.6483L13.5513 15.0245H13.6547L13.7582 14.8165L14.3271 14.3486L15.0513 13.9327L15.8271 13.6728L16.1375 13.6208H17.4306L18.103 13.8287H18.3616L18.4651 13.5168L19.0858 12.841L19.4996 12.4251L19.9134 12.0612L20.172 11.8532H20.2754L20.2237 8.99388L19.9134 8.8899L19.5513 8.57797L19.2927 8.16207L19.1892 7.6422L19.2927 7.17431L19.5513 6.7584L20.0168 6.3425L20.3789 6.23853ZM27.3099 11.8012L27.0513 11.9572L26.9996 12.0092V12.4251L28.034 12.9449L28.8616 13.4648L29.4306 13.9847L29.6892 14.1927L29.9478 14.6086L30.4651 14.4006L30.3616 13.8807L30.0513 13.4648L29.534 12.9449L28.603 12.3731L27.4134 11.8012H27.3099ZM21.6203 14.5046L21.5685 14.6086V15.3364L21.6203 15.3884H22.1892L22.2409 14.7645L22.1892 14.5046H21.6203ZM31.034 15.3884L30.8789 15.4404L30.9306 15.5443L30.8789 15.6483L30.7754 15.8563L30.8271 16.1682L31.0858 16.4801H31.3961L31.6547 16.2722L31.7065 16.1682V15.7523L31.5513 15.4923L31.3444 15.3884H31.034ZM35.8961 16.0122V16.792H36.4651V16.0122H35.8961ZM25.2927 16.844V17.7798H25.8099L25.9134 17.5199L25.8616 16.844H25.2927ZM15.8271 17.3119L15.7754 18.0397L15.8271 18.0917H16.4478V17.3119H15.8271ZM35.8444 17.5719L35.7927 18.4037H36.4651V17.5719H35.8444ZM32.7409 17.8838L32.6892 18.7156L32.7409 18.7676H33.4134V17.9358L33.1547 17.8838H32.7409ZM25.2927 18.4557V19.3394H25.8099L25.8616 18.5596L25.8099 18.4557H25.2927ZM18.5685 18.6636V19.3914L18.6203 19.4434H19.1375V18.6636H18.5685ZM35.8961 19.1835L35.8444 19.2355V20.1193H36.4651V19.1835H35.8961ZM30.2582 19.2875L30.2065 19.5474V20.0153L30.4651 20.1193H30.8271V19.2875H30.2582ZM25.2927 20.1712L25.1892 20.6391V21.0031L25.2409 21.055L25.7065 21.107L25.7582 21.055L25.8099 20.1712H25.2927ZM18.5685 20.2232L18.6203 21.0031H19.1892V20.2232H18.5685ZM32.7409 20.6391V21.367L32.7927 21.419H33.3616V20.7431L32.9996 20.6391H32.7409ZM15.8271 20.7951L15.8789 21.5749H16.4478V20.8991L16.3961 20.7951H15.8271ZM13.3444 21.367L13.2927 21.419V22.0428L13.3444 22.0948H13.8099L13.8616 22.0428V21.367H13.3444ZM25.2409 21.6789L25.1892 21.8868L25.2409 22.6667L25.8099 22.7186L25.7582 21.7309L25.2409 21.6789ZM23.6892 22.5107L23.3271 22.5627L23.2237 22.6667V24.6942L23.2754 25.0061H23.8444L23.9478 23.7584L23.9996 22.5107H23.6892ZM27.4134 22.5627L27.3616 22.6667L27.1547 24.7982V25.266H27.8271L27.9306 24.2783L27.9823 23.2385V22.6147L27.4134 22.5627ZM25.2927 23.3425L25.2409 23.6544V24.4342H25.8099L25.8616 23.9664V23.3425H25.2927ZM25.2927 25.1621L25.1892 25.318V25.8899L25.2927 26.0459H25.8616V25.1621H25.2927ZM25.2927 27.0336L25.1892 27.7095L25.2927 28.1774L25.8616 28.0734V27.0336H25.2927ZM27.4651 27.1896L27.103 27.2416L27.0513 28.9052V29.2691H27.6203L27.672 28.9572L27.7237 27.1896H27.4651ZM23.4306 27.2936L23.3789 27.3456V28.9052L23.4306 29.581L23.9996 29.529V27.8654L23.8961 27.2936H23.4306ZM25.3444 28.9052L25.1892 28.9572L25.1375 29.9449V30.9847L25.8616 30.9327V28.9052H25.3444ZM26.7927 30.2569L26.7409 31.0367L26.8444 31.7645L26.9478 32.1804H27.4651L27.4134 30.3089L27.1547 30.2569H26.7927ZM23.4306 30.4648L23.3271 31.1407V31.9725L23.6892 32.0764L23.9478 32.0245L23.9996 31.5046V30.5168L23.8961 30.4648H23.4306ZM22.0858 30.7248L21.3099 30.8807L19.4478 31.2446L18.5168 31.5566L18.103 31.8165L17.9478 32.0245L18.3616 32.2844L19.034 32.5443L20.4823 32.8563L21.2065 32.9602H22.034L22.1892 32.3364L22.2927 31.4006V30.7248H22.0858ZM28.7065 30.8807L28.7582 31.4006L28.9651 32.5443L29.1203 33.0122L30.4134 32.9083L31.8099 32.6483L32.7409 32.3364L33.1547 32.0764V31.8685L32.7409 31.6086L32.1203 31.3486L30.8271 31.0887L29.3789 30.8807H28.7065ZM25.2409 31.8165L25.1375 31.8685V33.0642H25.5513L25.7582 33.0122V31.8165H25.2409ZM27.1547 34L27.2065 34.6238L27.4134 34.5719V34.4679L27.672 34.3639L27.8271 34.2079V34.052L27.2582 34H27.1547ZM23.1203 34.052L23.0685 34.104L22.9651 34.6758L22.8616 35.0397L23.0168 35.1437L23.4306 35.1957L23.6375 34.5719L23.5858 34.104L23.4823 34.052H23.1203ZM25.4996 34L25.1375 34.052L25.0858 34.104V35.3517H25.7582V34.052L25.4996 34ZM27.9823 35.2477L27.6203 35.3517L27.672 35.9235L27.9823 37.0153L28.034 37.0673H28.3961L28.5513 37.0153V36.5474L28.2927 35.5596L28.1375 35.2477H27.9823ZM22.6547 36.0275L22.1892 37.4312L22.1375 37.9511L22.4996 38.159L22.7065 38.107L22.9651 37.3272L23.2754 36.1315V36.0275H22.6547ZM25.3444 36.2355L25.1375 36.2875L25.1892 36.8073L25.2409 37.4312H25.603L25.8099 37.3792V36.9113L25.6547 36.2355H25.3444ZM28.7065 38.8349L28.5513 38.8868L28.603 39.2508L29.1203 40.6024L29.172 40.7064H29.7927L29.6375 40.0826L29.1203 38.8349H28.7065ZM24.2582 39.1468L24.103 40.2905L23.8961 40.9664V41.0703L24.2065 41.2783H24.3616L24.5685 40.9664L24.7237 40.7064L24.8271 40.0826L24.8789 39.5107L24.7754 39.1468H24.2582ZM21.7237 39.1988L21.2065 40.1865L20.9996 40.7064L21.1547 40.7584L21.6203 40.7064L22.1375 39.8226L22.1892 39.4587L21.8271 39.1988H21.7237ZM27.0513 41.2263L26.7409 41.2783L27.1547 42.37L27.2065 42.526H27.7237L27.8271 42.266L27.7754 42.0061L27.3616 41.2783L27.3099 41.2263H27.0513ZM32.0168 41.7982L31.9134 41.9541V42.526L32.6375 42.578H33.5168V42.1101L33.2582 41.8501L32.8961 41.7982H32.0168ZM17.8961 41.8501L17.7927 42.0581L17.9478 42.526L19.1892 42.474L19.2409 41.8501H17.8961Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.9999 7.33032H12.3102L12.3619 7.38231V8.16213H11.8964L11.793 7.8502V7.53827L11.9481 7.48629L11.9999 7.33032Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.7934 7.43433H39.3107V8.11017L39.052 8.16215L38.7417 7.9542L38.7934 7.43433Z"
      fill="#C6B7FF"
    />
    <path
      d="M34.6552 8.37012H35.3277L35.4311 8.4221V10.7616H34.9139L34.8621 10.6056L34.7587 9.04596L34.6035 8.78602V8.4221L34.6552 8.37012Z"
      fill="#C6B7FF"
    />
    <path
      d="M15.8793 8.42212H16.3448L16.5517 8.52609L16.6035 9.14995L16.5517 10.8655H16.0345L15.9311 10.7616L15.8793 8.942L15.7759 8.89001V8.47411L15.8793 8.42212Z"
      fill="#C6B7FF"
    />
    <path
      d="M39.9312 8.68188H40.3967V9.35773H39.9312V8.68188Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.7417 8.78589H39.2589L39.3107 9.40974L39.2589 9.46173H38.8969L38.7417 9.35775V8.78589Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.793 8.88989H12.3102V9.61772H11.8447L11.793 9.56573V8.88989Z"
      fill="#C6B7FF"
    />
    <path
      d="M39.9828 10.0857H40.3966L40.4484 10.1377V10.8655H40.0346L39.8794 10.3976L39.9311 10.1377L39.9828 10.0857Z"
      fill="#C6B7FF"
    />
    <path d="M38.793 10.1377H39.3619V10.8655H38.793V10.1377Z" fill="#C6B7FF" />
    <path
      d="M11.793 10.2417H12.2585L12.3619 10.4497V10.9695L12.3102 11.0215H11.793V10.2417Z"
      fill="#C6B7FF"
    />
    <path
      d="M8.12057 10.4495H8.74126L8.68954 10.8654L8.58609 11.1253H8.12057L8.06885 11.0733V10.6574L8.12057 10.4495Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.3101 10.4495H42.879V11.1773H42.517L42.3101 10.6054V10.4495Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.7412 11.6453L12.2067 11.6973L12.2585 11.7492V12.3731L12.155 12.4771L11.7929 12.4251L11.7412 12.3731V11.6453Z"
      fill="#C6B7FF"
    />
    <path
      d="M7.86178 11.6973H8.37902L8.48247 11.7493V11.8532H8.58592V13.3089L8.5342 14.2447H7.96523L7.91351 14.1407L7.86178 12.4771L7.81006 12.2691V11.8532L7.86178 11.6973Z"
      fill="#C6B7FF"
    />
    <path
      d="M15.8794 11.6973H16.5001L16.6035 12.0092V12.789L16.5518 12.893H15.9311L15.8794 12.2691V11.6973Z"
      fill="#C6B7FF"
    />
    <path
      d="M34.707 11.6973H35.3277V12.841H34.6553V11.8532L34.707 11.6973Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.7416 11.6973H39.3623L39.6209 11.8532L39.6727 12.3211L39.6209 12.789L39.5692 14.1927H39.0003V12.2691L38.8451 12.3211L38.6899 12.2691L38.6382 12.1652V11.8532L38.7416 11.6973Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.5171 11.7493H42.9309L43.3964 11.9052V14.1407H42.8274V12.3211H42.5171V11.7493Z"
      fill="#C6B7FF"
    />
    <path
      d="M12.0516 13.1008L12.3102 13.1528V14.0366H11.7412V13.2048L12.0516 13.1008Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.6382 14.7126H12.3106V15.3885H11.6382V14.7126Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.7238 14.8684H43.3962L43.6031 15.0764L43.7583 15.4403V16.636L43.6031 17.2598L43.4996 17.3638H42.7238L42.31 17.1559L42.2065 16.792V15.3883L42.3617 15.0764L42.5686 14.9204L42.7238 14.8684ZM42.8272 15.6482L42.7755 15.7522V16.8439L43.0859 16.8959L43.241 16.48V15.8562L42.9824 15.7002L42.8272 15.6482Z"
      fill="#C6B7FF"
    />
    <path
      d="M7.81034 14.9724H8.7931L9 15.1804L9.10345 15.8562L9.15517 16.4281V16.9999L9 17.2599L8.7931 17.3119H7.86207L7.60345 17.1039L7.5 16.636V15.1804L7.65517 15.0244L7.81034 14.9724ZM8.27586 15.7002L8.12069 15.7522L8.06897 15.8562V16.844H8.58621L8.53448 16.1681L8.48276 15.7002H8.27586Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.17223 15.3884H5.58602L5.5343 15.8563L5.48257 16.1682H5.01706L4.96533 16.0643L5.06878 15.5964L5.17223 15.3884Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.5171 15.3884H45.9826V16.0643H45.5171V15.3884Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.5688 16.74H45.9826L46.0343 16.844V17.6238H45.5688L45.5171 17.5718V16.792L45.5688 16.74Z"
      fill="#C6B7FF"
    />
    <path
      d="M4.86182 16.844L5.37906 16.948L5.48251 17.0519V17.7278H4.91354L4.86182 17.4678V16.844Z"
      fill="#C6B7FF"
    />
    <path
      d="M7.96582 18.2478H8.58651L8.74168 18.4038V20.4313L8.68996 20.7432H8.17272L8.06927 20.6392L8.01754 18.7157L7.96582 18.6637V18.2478Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.9825 18.1958L43.3963 18.2478V20.6392H42.9308L42.8274 20.5353V18.8197L42.4136 18.6637V18.2478L42.9825 18.1958Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.5688 18.2998H45.9826L46.0343 18.3518V19.0796L45.9826 19.1316H45.6205L45.5171 19.0276V18.4038L45.5688 18.2998Z"
      fill="#C6B7FF"
    />
    <path
      d="M4.86182 18.3516H5.43078V19.1314L5.01699 19.1834L4.86182 19.0794V18.3516Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.5688 19.8074H46.0343V20.5352H45.5688L45.5171 20.4832V19.8594L45.5688 19.8074Z"
      fill="#C6B7FF"
    />
    <path
      d="M4.65556 19.8594H5.63832L5.89694 20.0153L6.00039 20.1713V21.8869L5.89694 22.1468L5.58659 22.2508L4.60384 22.1988L4.44866 21.9389L4.34521 21.419V20.5352L4.39694 20.0153L4.65556 19.8594ZM5.22453 20.3793L5.06935 20.4832L4.9659 21.523L5.22453 21.7829L5.43142 21.8349L5.48315 21.7829V20.3793H5.22453Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.5171 21.2629H46.0343L46.1378 21.5229L45.9826 21.9388H45.5171V21.2629Z"
      fill="#C6B7FF"
    />
    <path
      d="M46.4482 21.4189H47.0172L47.2758 21.7309L47.3276 22.0428H46.862L46.6551 21.9908L46.5517 21.8348L46.4482 21.4189Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.4658 21.5229H43.3451L43.3969 21.8349V23.9664L43.3451 24.0184H42.8279L42.7762 23.9664L42.7244 22.2508L42.5693 22.0948L42.4658 22.0428V21.5229Z"
      fill="#C6B7FF"
    />
    <path
      d="M8.58644 21.5229L8.68989 21.5749V24.0703H8.12093L8.0692 22.6147L8.01748 22.0948L7.8623 21.5749L8.58644 21.5229Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.06878 22.9785L5.48257 23.0305L5.5343 23.0825V23.7583H5.01706L4.96533 23.0305L5.06878 22.9785Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.3103 23.0305H46.2414L46.6034 23.3424L46.6552 23.4984L46.7069 24.4342L46.6552 24.9541L46.3966 25.318L46.1379 25.422L45.2069 25.4739L45.0517 25.266L45 25.0061V23.4464L45.1552 23.1345L45.3103 23.0305ZM45.6207 23.6544L45.5172 24.0183V24.6941L45.6724 24.8501L46.0345 24.9541L45.9828 23.7583L45.7241 23.6544H45.6207Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.0693 24.4343H5.43137L5.58654 24.5903V25.1622L5.53482 25.2141H5.01758V24.4863L5.0693 24.4343Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.5693 24.8501H43.3969L43.4486 25.6819V26.9296L43.3451 27.1376H42.8796L42.7762 27.0336L42.7244 25.5259L42.4658 25.422V24.9021L42.5693 24.8501Z"
      fill="#C6B7FF"
    />
    <path
      d="M14.0176 25.1101H14.7934L14.9486 25.2661L15.0003 26.3058V27.4496H14.4314L14.3279 27.0856L14.2762 25.7859L14.0176 25.526V25.1101Z"
      fill="#C6B7FF"
    />
    <path
      d="M36.4653 25.2141L37.086 25.2661V25.89L36.9308 25.9939H36.5688L36.5171 25.9419L36.4653 25.2141Z"
      fill="#C6B7FF"
    />
    <path
      d="M17.5863 25.3181H18.1553L18.0001 27.1897L17.9484 27.7615H17.5863L17.4829 27.6576L17.4312 26.8777V26.0459L17.5863 25.3181Z"
      fill="#C6B7FF"
    />
    <path
      d="M19.2935 25.3181H19.759L19.8107 26.0979H19.3452L19.2935 26.0459V25.3181Z"
      fill="#C6B7FF"
    />
    <path
      d="M39.2072 25.2661H39.4141V26.0459L39.3624 26.0979H38.8451L38.7417 25.942V25.5261L38.8451 25.3181L39.2072 25.2661Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.6895 25.4221H12.2584L12.3101 25.5781V26.2019H11.7929L11.6895 25.4221Z"
      fill="#C6B7FF"
    />
    <path
      d="M33.0518 25.4221H33.7759L33.7242 26.046L33.569 26.2019L33.0518 26.1499V25.4221Z"
      fill="#C6B7FF"
    />
    <path
      d="M31.3446 25.8379H31.7067V26.0978L31.8101 25.8899V26.5657H31.2929L31.1895 26.1498L31.3446 25.8379Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.01706 25.9419H5.5343V26.5657L5.48257 26.6177H5.01706L4.96533 26.5657V25.9939L5.01706 25.9419Z"
      fill="#C6B7FF"
    />
    <path
      d="M8.37918 25.9419H8.79297L9.20676 26.0459L9.56883 26.3058L9.87918 26.7737L9.9309 26.9816V27.3976L9.77573 27.8654L9.51711 28.1254L9.46538 28.2813L8.99987 28.4373V29.3211L9.05159 30.3609L9.56883 31.0367L9.9309 31.4526L10.7585 31.9725L11.1723 32.5963L11.3792 32.8563L11.6378 32.9602L12.9826 33.0122H13.9137L14.5861 33.6361L15.2585 34.2599L15.8275 34.7278L16.1895 35.0917L16.6033 35.4557L16.7585 35.6636L16.8102 35.9755V36.8073L16.7585 38.5229H16.1378L16.0343 36.5994L15.9826 36.0795L15.6206 35.6636L15.2068 35.2997L14.5343 34.6758L14.1206 34.3119L13.7585 34L13.5516 33.844L12.724 33.792L11.1723 33.7401L10.7585 33.3761L10.2412 32.7003L9.87918 32.3884L9.41366 32.0245L8.99987 31.5046L8.94814 31.3486L8.79297 31.2966L8.53435 31.0367L8.27573 30.7768L8.224 28.4893L7.81021 28.2294L7.44814 27.8654L7.29297 27.3976V27.0336L7.44814 26.6177L7.75849 26.2538L8.17228 25.9939L8.37918 25.9419ZM8.48262 26.7737L8.27573 26.8777L8.17228 27.0336V27.3976L8.37918 27.6055L8.68952 27.6575L8.94814 27.5015L9.05159 27.3976V27.0336L8.84469 26.8257L8.48262 26.7737Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.8792 26.5137H46.1378L46.0861 27.2935L46.0343 27.3455H45.5171L45.5688 26.6176L45.8792 26.5137Z"
      fill="#C6B7FF"
    />
    <path
      d="M36.3105 26.6177H36.9312L36.983 26.6697V27.4495H36.3105V26.7736H36.7243V26.6697H36.3105V26.6177Z"
      fill="#C6B7FF"
    />
    <path
      d="M19.2412 26.7217H19.7585L19.8619 26.8776V27.7614H19.3964L19.2929 27.6055L19.2412 26.7217Z"
      fill="#C6B7FF"
    />
    <path
      d="M33.1553 26.7737H33.7242L33.8277 26.9816V27.7095L33.1553 27.6575V26.7737Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.7934 26.8777L39.3624 26.9297V27.0856L39.3107 27.8655H38.7934L38.7417 27.8135V26.9297L38.7934 26.8777Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.7412 27.0857H12.3101L12.4136 27.1897V27.7615L12.2067 27.8135H11.6895V27.1377L11.7412 27.0857Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.01758 27.1897H5.58654V28.0735L5.4831 28.1255H5.01758V27.1897Z"
      fill="#C6B7FF"
    />
    <path
      d="M31.1899 27.1897H31.6554L31.7589 27.3976L31.8106 28.0215H31.1899L31.1382 27.9695V27.2417L31.1899 27.1897Z"
      fill="#C6B7FF"
    />
    <path
      d="M3.82757 27.3455H4.39653L4.44826 27.3974V27.9173L4.39653 27.9693H3.77585L3.72412 27.9173V27.5014L3.82757 27.3455Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.5175 27.9695L43.0348 28.0735L43.5003 28.3854L43.7589 28.7493L43.8624 29.1652V29.5811L43.6038 30.101L43.19 30.5169L42.9831 30.6209L42.8279 32.0245L42.052 32.8043L41.6382 33.1683L41.2762 33.5322L41.0175 33.5842H38.3796L38.0175 33.7401L37.6038 34.312L37.2934 34.6239L37.2417 34.7799L37.19 36.4435L36.9313 37.0154L36.7244 37.3793L36.0003 38.1071L35.5865 38.471L35.3279 38.679L34.8624 38.731L33.4658 38.7829L33.5175 38.471L33.7244 38.1591L33.9831 37.9511L34.5003 37.8472H35.121L35.2244 37.6392L35.4831 37.3793H35.5865V37.2753L35.9486 36.9634L36.052 36.7034L35.8969 36.7554L34.3451 36.7034L34.2417 36.6514V35.9756L34.7589 35.9236H36.5175V34.208L36.6727 33.9481L37.19 33.5842L37.6038 32.9603L37.9141 32.7524H40.8624L41.4313 32.2845L41.69 32.0245L41.9486 31.7646L42.1555 31.3487V30.6728L41.5865 30.3609L41.2762 29.997L41.121 29.6331V29.0092L41.2762 28.6453L41.4831 28.3854L42.0003 28.0735L42.5175 27.9695ZM42.3106 28.9053L42.052 29.1132L42.0003 29.4771L42.1038 29.7891L42.3106 29.893H42.621L42.8796 29.7371L42.9831 29.5291L42.9313 29.1652L42.621 28.9053H42.3106Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.4653 28.0215H46.0343V28.7493H45.4653V28.0215Z"
      fill="#C6B7FF"
    />
    <path
      d="M35.7928 28.3333H36.2583L36.6204 28.4892L36.9824 28.8531L37.1893 29.321V29.7889L36.9824 30.2048L36.6721 30.4648L36.4135 30.6207L36.2066 30.6727H35.7411L35.3273 30.5167L34.9652 30.2048L34.7583 29.7369V29.217L34.9652 28.8011L35.3273 28.4892L35.7928 28.3333ZM35.948 29.0611L35.7411 29.1651L35.6893 29.269V29.581L35.8445 29.7369L36.2066 29.7889L36.3617 29.529L36.31 29.217L36.1031 29.0611H35.948Z"
      fill="#C6B7FF"
    />
    <path
      d="M15.6208 28.3333H16.3449L16.8621 28.6972V28.8011L17.069 28.9051L17.638 29.373L17.8966 29.7889V29.8929L17.5863 30.0488L17.069 30.1008L16.6552 29.6329L16.2414 29.321L16.138 29.217L15.207 29.1651H14.3794L14.3277 30.7247V31.4525H13.7587L13.6552 31.1926L13.6035 30.8807V28.4892L13.707 28.3852L15.6208 28.3333Z"
      fill="#C6B7FF"
    />
    <path
      d="M33.103 28.4373H33.5685L33.6203 28.5412V29.2171H33.1548L33.103 29.1131V28.4373Z"
      fill="#C6B7FF"
    />
    <path
      d="M19.2935 28.4893H19.8624L19.9141 29.1131L19.3452 29.1651L19.2935 29.1131V28.4893Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.6895 28.5933H12.3619V29.4251L12.3101 29.4771H11.6895V28.5933Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.8452 28.6453H39.3625L39.4659 29.4771V29.789H38.8452V28.6453Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.01706 28.8013L5.5343 28.8533V29.5291H5.06878L4.96533 28.9572L5.01706 28.8013Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.4653 29.425H46.0343L46.086 30.1529L46.0343 30.2049H45.5171L45.4653 30.1529V29.425Z"
      fill="#C6B7FF"
    />
    <path
      d="M4.91354 30.2568H5.63768L5.74113 30.3608V32.7003H5.17216V30.8807L4.91354 30.7767L4.86182 30.4648L4.91354 30.2568Z"
      fill="#C6B7FF"
    />
    <path
      d="M11.7412 30.2568H12.2584V30.9847H11.7412L11.6895 30.9327V30.3088L11.7412 30.2568Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.8965 30.5688H39.4137V31.0887L39.362 31.2967H38.8965V30.5688Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.4653 30.9326H45.9825L46.0343 31.0366V31.6604H45.4653L45.4136 31.6085V31.0366L45.4653 30.9326Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.5171 32.5444H45.9826V33.2203L45.9308 33.2723H45.4653V32.5964L45.5171 32.5444Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.01758 33.688H5.4831L5.58654 33.792V34.3118L5.53482 34.3638L5.01758 34.4158V33.688Z"
      fill="#C6B7FF"
    />
    <path
      d="M45.4653 34H45.9825L46.0343 34.052V34.5719L45.9308 34.7798L45.4136 34.7278L45.4653 34Z"
      fill="#C6B7FF"
    />
    <path
      d="M33.103 34.416H33.8272V35.1958L33.1548 35.2478L33.103 34.416Z"
      fill="#C6B7FF"
    />
    <path
      d="M9.36215 34.5198H9.98284L10.138 34.7277L10.1897 38.2109L9.77595 38.2629L9.4656 38.2109L9.41388 38.1069V36.6513L9.4656 35.5075V35.3516L8.58629 35.2476L8.37939 34.9877L8.43112 34.6238L8.48284 34.5718L9.36215 34.5198Z"
      fill="#C6B7FF"
    />
    <path
      d="M19.1894 34.5718H19.7584L19.8101 34.6238V35.2476L19.7584 35.2996H19.2411L19.1377 35.1436V34.7277L19.1894 34.5718Z"
      fill="#C6B7FF"
    />
    <path
      d="M31.7588 34.6238H32.1725L32.3277 34.7797V35.4036H31.8105L31.707 35.1956V34.7278L31.7588 34.6238Z"
      fill="#C6B7FF"
    />
    <path
      d="M42.1034 34.9358H42.7241L43.1896 35.2477L43.3965 35.5077L43.5 35.8196V36.4954L43.2931 36.9113L42.8276 37.2752L42.6724 37.3272H42.1034L41.7414 37.1713L41.431 36.8074L41.2241 36.3395V35.8196L41.3276 35.5077L41.6379 35.1437L42.1034 34.9358ZM42.1552 35.8196L42 36.0275V36.2875L42.2069 36.4434H42.6207L42.7758 36.2875V35.9755L42.6207 35.8196H42.1552Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.9481 35.0918H39.4137V35.8196L38.8964 35.9236L38.793 35.7676L38.8964 35.1438L38.9481 35.0918Z"
      fill="#C6B7FF"
    />
    <path
      d="M5.01758 35.1438H5.43137L5.4831 35.6637L5.37965 35.8196H5.0693L5.01758 35.6637V35.1438Z"
      fill="#C6B7FF"
    />
    <path
      d="M33.2065 35.9756H33.7755L33.8272 36.0276V36.7034L33.2065 36.7554V35.9756Z"
      fill="#C6B7FF"
    />
    <path
      d="M34.0864 36.0276H34.1384V36.7034L33.9824 36.6514L34.0864 36.0276Z"
      fill="#C6B7FF"
    />
    <path
      d="M19.1377 36.0796H19.7584V36.7554H19.1894L19.1377 36.7034V36.0796Z"
      fill="#C6B7FF"
    />
    <path
      d="M31.707 36.1316H32.2759L32.2242 36.8074H31.8104L31.6552 36.6515L31.6035 36.3395L31.707 36.1316Z"
      fill="#C6B7FF"
    />
    <path
      d="M12.7758 36.2354H13.2413L13.7068 36.3913L14.0171 36.5993L14.224 36.8592L14.3275 37.0672L14.3792 37.587L14.224 38.0549L13.8102 38.5228L13.4482 38.6788H13.0344L12.5689 38.5228L12.1551 38.1589L11.8965 37.691L11.8447 37.2231L11.9999 36.8072L12.3102 36.4433L12.5689 36.2873L12.7758 36.2354ZM13.0344 37.0672L12.7758 37.2751L12.724 37.587L12.9309 37.847L13.1896 37.899L13.4482 37.743L13.5516 37.639V37.2751L13.3447 37.1191L13.0344 37.0672Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.8969 36.5994H39.4142V37.2232L39.3625 37.2752H38.8969L38.8452 37.2232V36.6514L38.8969 36.5994Z"
      fill="#C6B7FF"
    />
    <path
      d="M38.9999 37.9512H39.5688L39.724 38.0551V39.0429L39.6723 40.3946L39.6206 40.4986H38.9999L38.9481 40.3946L38.8964 38.523L38.793 38.471V38.0551L38.9999 37.9512Z"
      fill="#C6B7FF"
    />
    <path
      d="M9.41406 39.0427H10.0348L10.0865 39.1987V39.7186L10.0348 39.7706H9.41406V39.0427Z"
      fill="#C6B7FF"
    />
    <path
      d="M13.3965 44.3975H24.3103V45.2293H14.2241L13.7586 44.8654L13.3965 44.5014V44.3975Z"
      fill="#C6B7FF"
    />
    <path
      d="M25.7588 44.3975H33.7243V45.2293H25.7588V44.3975Z"
      fill="#C6B7FF"
    />
    <path
      d="M36.4654 44.3455H37.3447L37.5516 44.3974V44.6574L37.1895 45.0213L36.8274 45.2293H35.0171V44.3974L36.4654 44.3455Z"
      fill="#C6B7FF"
    />
    <path
      d="M16.6035 46.113H19.707V46.9448H18.207L16.6552 46.321L16.6035 46.113Z"
      fill="#C6B7FF"
    />
    <path d="M21 46.113H29.069V46.9448H21V46.113Z" fill="#C6B7FF" />
    <path
      d="M34.8621 46.0613H35.069L34.9655 46.2692L34.1897 46.5292L33.5173 46.7891L33 46.9451H30.7759V46.1133L34.8621 46.0613Z"
      fill="#C6B7FF"
    />
    <path
      d="M25.6035 47.6208L29.3793 47.6728V47.7768L28.7069 47.8808L26.2759 48.0887H25.5518V47.6728L25.6035 47.6208Z"
      fill="#C6B7FF"
    />
  </svg>
);
